import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PlainRightArrow } from '@/assets/PlainRightArrow';
import { StarIcon } from '@/assets';
import { cn } from '@/lib/utils';
import { InfoColumnsSliceWithSliderStoriesPrimaryDetailsItem } from '../../../prismicio-types';

export default function AnimatedSlider({
  details,
}: {
  details: InfoColumnsSliceWithSliderStoriesPrimaryDetailsItem[];
}) {
  return (
    <div className="relative overflow-hidden">
      <div
        className="animate-scroll-horizontal pb-12 flex flex-row"
        style={{
          animation: 'scroll-horizontal 20s linear infinite',
        }}
      >
        {details.map((column, index) => (
          <PrismicNextLink field={column.link} key={index} className={`px-2`}>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 w-[350px] h-[400px] flex flex-col">
              <div className="flex justify-between items-center mb-4">
                <PrismicNextImage
                  className="h-16 w-16 object-contain"
                  field={column.icon}
                  fallbackAlt=""
                />
                <PlainRightArrow className="h-5 w-5" arrowFill="#03BF9E" />
              </div>
              <p className="text-gray-900 font-medium mb-4">{column.text}</p>
              <div className="flex mb-4">
                {(() => {
                  const rating = column.rating ?? 0;
                  return [...Array(5)].map((_, i) => (
                    <StarIcon
                      key={i}
                      fill=""
                      className={cn(
                        'h-5 w-5 mr-1',
                        i < Math.floor(rating)
                          ? 'text-yellow-400 fill-yellow-400'
                          : i < rating
                            ? 'text-yellow-400 fill-yellow-400 opacity-50'
                            : 'text-gray-300',
                      )}
                    />
                  ));
                })()}
              </div>{' '}
              <p className="text-gray-500 text-sm flex-grow">
                “{column.quote}”
              </p>
              <div className="mt-4">
                <p className="text-black font-semibold">{column.author}</p>
                <p className="text-gray-500 text-sm">{column.title}</p>
              </div>
            </div>
          </PrismicNextLink>
        ))}
      </div>
    </div>
  );
}
